'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildExpression = buildExpression;
exports.buildSet = buildSet;
exports.buildFilter = buildFilter;

var _dateUtils = require('./dateUtils');

var _genericUtils = require('./genericUtils');

function buildExpression(options) {
  if (!options || !options.field) return null;

  var fieldName = options.field.name;
  var fieldType = (0, _genericUtils.getGenericFieldType)(options.field.type);
  var inputValue = options.value || { code: '' };
  var operator = options.operator;

  var value = void 0;
  if (!operator.omitValue) {
    value = '' + (operator.prefix || '') + inputValue.code + (operator.suffix || '');
  }

  var expression = void 0;
  switch (fieldType) {
    case 'string':
      expression = fieldName + ' ' + operator.operator;
      expression += operator.omitValue ? '' : ' \'' + value + '\'';
      break;
    case 'number':
      expression = fieldName + ' ' + operator.operator;
      expression += operator.omitValue ? '' : ' ' + value;
      break;
    case 'date':
      var d = inputValue.code && inputValue.code !== '' ? new Date(inputValue.code) : new Date();

      var date = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds());

      if (operator.fullDay) {
        expression = fieldName + ' ' + operator.operator;
        expression += ' timestamp \'' + (0, _dateUtils.getDayStart)(date) + '\' AND timestamp \'' + (0, _dateUtils.getDayEnd)(date) + '\'';
      } else if (operator.relativeDate) {
        expression = fieldName + ' ' + operator.operator + ' CURRENT_TIMESTAMP - ' + (0, _dateUtils.convertTimeSpanToSQLDays)(inputValue.timeSizeValue, inputValue.timeSpanValue) + ' AND CURRENT_TIMESTAMP';
      } else {
        expression = fieldName + ' ' + operator.operator;
        expression += operator.omitValue ? '' : ' \'' + (0, _dateUtils.formatDate)(date, 'date') + '\'';
      }
      break;
    case 'epoch':
      var epochD = inputValue.code && inputValue.code !== '' ? new Date(inputValue.code) : new Date();

      var epochDate = new Date(epochD.getUTCFullYear(), epochD.getUTCMonth(), epochD.getUTCDate(), epochD.getUTCHours(), epochD.getUTCMinutes(), epochD.getUTCSeconds());

      expression = fieldName + ' ' + operator.operator;

      if (operator.fullDay) {
        expression += ' ' + (0, _dateUtils.getEpochDayStart)(epochDate) + ' AND ' + (0, _dateUtils.getEpochDayEnd)(epochDate);
      } else if (operator.alias === 'is before') {
        expression += ' ' + (0, _dateUtils.getEpochDayStart)(epochDate);
      } else if (operator.alias === 'is after') {
        expression += ' ' + (0, _dateUtils.getEpochDayEnd)(epochDate);
      } else if (operator.alias === 'is on or before') {
        expression += ' ' + (0, _dateUtils.getEpochDayEnd)(epochDate);
      } else if (operator.alias === 'is on or after') {
        expression += ' ' + (0, _dateUtils.getEpochDayStart)(epochDate);
      } else {
        expression += operator.omitValue ? '' : ' \'' + (0, _dateUtils.formatDate)(epochDate, 'epoch') + '\'';
      }

      break;
    default:
  }

  return expression;
}

function buildSet(options) {
  // options is an array of expressions and a boolean 'mustMatchAll'
  var mustMatchAll = options.mustMatchAll,
      expressions = options.expressions;

  var setOperator = mustMatchAll ? 'AND' : 'OR';

  var set = Object.keys(expressions).map(function (key) {
    var expression = buildExpression(expressions[key]);

    if (!expression) return null;

    return '(' + expression + ')';
  }).filter(function (expression) {
    return expression;
  });

  if (set.length) {
    return set.join(' ' + setOperator + ' ');
  }

  return '';
}

function buildFilter(options) {
  // options is an array of sets and a boolean 'mustMatchAll'
  var mustMatchAll = options.mustMatchAll,
      sets = options.sets;

  var filterOperator = mustMatchAll ? 'AND' : 'OR';

  var filter = Object.keys(sets).map(function (key) {
    var set = buildSet(sets[key]);

    if (!set) return null;

    if (Object.keys(sets).length <= 1) {
      return set;
    }

    return '(' + set + ')';
  }).filter(function (set) {
    return set;
  });

  if (filter.length) {
    return filter.join(' ' + filterOperator + ' ');
  }

  return '';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/utils/sqlUtils.js
// module id = 684
// module chunks = 0